(function () {

    function initProductCardSliders() {
        const containers = document.querySelectorAll('.card-product-slider-container:not(.slider-initialized)');

        if (containers.length === 0) return;

        containers.forEach(function (container) {
            const swiperEl = container.querySelector('.product-card-swiper');
            if (!swiperEl) return;

            const slides = swiperEl.querySelectorAll('.swiper-slide');
            if (slides.length < 2) {
                container.classList.add('slider-initialized');
                return;
            }

            // ✅ Simple autoplay swiper
            new Swiper(swiperEl, {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                speed: 500,
                autoplay: false,
                // autoplay: {
                //     delay: 1500, // adjust speed here
                //     disableOnInteraction: false,
                //     pauseOnMouseEnter: false
                // },

                pagination: {
                    el: container.querySelector('.swiper-pagination'),
                    clickable: true,
                },

                allowTouchMove: true,
            });

            container.classList.add('slider-initialized');
        });
    }

    function checkSwiperAndInit() {
        if (typeof Swiper !== 'undefined') {
            initProductCardSliders();
        } else {
            let attempts = 0;
            const interval = setInterval(function () {
                attempts++;
                if (typeof Swiper !== 'undefined') {
                    clearInterval(interval);
                    initProductCardSliders();
                } else if (attempts > 100) {
                    clearInterval(interval);
                }
            }, 100);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', checkSwiperAndInit);
    } else {
        checkSwiperAndInit();
    }

    document.addEventListener('shopify:section:load', function () {
        checkSwiperAndInit();
    });

    const observer = new MutationObserver(function (mutations) {
        let shouldInit = false;
        mutations.forEach(function (mutation) {
            if (mutation.addedNodes.length > 0) {
                mutation.addedNodes.forEach(node => {
                    if (
                        node.nodeType === 1 &&
                        (node.querySelector('.card-product-slider-container') ||
                            node.classList.contains('card-product-slider-container'))
                    ) {
                        shouldInit = true;
                    }
                });
            }
        });
        if (shouldInit) {
            initProductCardSliders();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

})();